/** The leads API returns at most this many rows per request (server max). */
export const LEADS_FETCH_LIMIT = 500

/**
 * Text for the notice shown when the board and table hold only part of the
 * pipeline (QA C2-1). The page fetches the newest LEADS_FETCH_LIMIT leads in
 * one request, so on a bigger account the rest are missing with nothing on
 * screen saying so. Returns null when everything is shown.
 *
 * Shown only once the fetch actually hit the cap: the stats total refreshes
 * faster than the list, so comparing the two alone would flash the notice
 * for a few seconds after every new lead.
 */
export function boardCapNotice(args: {
  readonly fetched: number
  readonly total: number | undefined
  readonly campaignFiltered: boolean
}): string | null {
  const { fetched, total, campaignFiltered } = args
  if (fetched < LEADS_FETCH_LIMIT) return null
  if (campaignFiltered) {
    return `Showing the newest ${fetched.toLocaleString()} leads in this campaign. Older leads are not on the board or in the table yet.`
  }
  if (total === undefined || total <= fetched) return null
  return `Showing your newest ${fetched.toLocaleString()} of ${total.toLocaleString()} leads. Older leads are not on the board or in the table yet.`
}
